<newsletter-svg-sprite />

@if (newsletter(); as nl) {
  <div [formGroup]="form" class="newsletter-form" [style.background]="brand()?.primaryColor"
    [class.popup]="mode() === 'popup'" [class.home-page]="mode() === 'home-page'">
    <div class="container">
      <h3 class="page-title">{{nl.callToAction ? nl.callToAction :
      ('newsLetter.subscribeToOurNewsletter' | translate)}}</h3>
      <div class="spam-msg d-flex justify-content-center align-items-center">
        <div class="icon">
          <svg>
            <use xlink:href="#unsubscribeIcon"></use>
          </svg>
        </div>
        <span class="spam-msg-txt">{{nl.infoNote ? nl.infoNote : ('newsLetter.defaultDisclaimer' |
          translate)
        }}</span>
      </div>
      <div class="email-wrapper d-flex align-items-center">
        <div class="form-group w-100">
          <input type="text" class="form-control" placeholder="{{('newsLetter.enterYourEmail' | translate)}}"
            formControlName="email">
        </div>
        <button class="btn-accent" [disabled]="subscribed()" (click)="saveEmail()">
          <span>{{ 'newsLetter.subscribe' | translate }}</span>
        </button>
      </div>
      <div class="checkbox-container d-flex align-items-center">
        <div class="form-checkbox">
          <input formControlName="checkbox" type="checkbox" class="form-checkbox-input"
            [style.accent-color]="brand()?.accentColor" #consentWarning>
        </div>
        <span class="consent-warning noselect" (click)="toggle(consentWarning)">
          {{nl.consentWarning ? nl.consentWarning : ('newsLetter.defaultConsentNotice' | translate)}}
        </span>
      </div>
    </div>
    <img class="bg-send-img" [src]="newsletterUrl" alt="">
  </div>
}
